import request from "root/js/request";

// Получаем историю всех запросов
export const getWBDynamicKeywordsIds = async ({ keywords, ordering, limit, offset, ...rest }) => {
  const response = await request({
    url: `/wb_dynamic/keywords_ids/`,
    method: "post",
    params: {
      ordering,
      limit,
      offset,
      ...rest,
    },
    data: {
      keywords,
    },
  });
  return response.data;
};
